import { api } from './cloudflareAPI';

export const leadService = {
  // Add a new lead
  async addLead(leadData) {
    try {
      const result = await api.createLead(leadData);
      return { success: true, id: result.id };
    } catch (error) {
      console.error('Error adding lead:', error);
      return { success: false, error: error.message };
    }
  },

  // Get all leads with pagination and filtering
  async getLeads(params = {}) {
    try {
      const result = await api.getLeads(params);
      return { 
        success: true, 
        leads: result.leads || [],
        pagination: result.pagination
      };
    } catch (error) {
      console.error('Error getting leads:', error);
      return { success: false, leads: [], error: error.message };
    }
  },

  // Listen to leads in real-time (polling simulation)
  onLeadsChange(callback, params = {}) {
    let intervalId;
    let isFirstLoad = true;
    
    const fetchLeads = async () => {
      try {
        console.log('Fetching leads...');
        const result = await api.getLeads(params);
        console.log('Leads fetched:', result);
        
        if (result.leads) {
          // Convert date strings to Date objects for compatibility
          const leads = result.leads.map(lead => ({
            ...lead,
            createdAt: lead.createdAt ? new Date(lead.createdAt) : new Date()
          }));
          callback(leads);
        } else {
          // If no leads property, return empty array
          callback([]);
        }
      } catch (error) {
        console.error('Error fetching leads:', error);
        // On error, return empty array to stop loading state
        if (isFirstLoad) {
          callback([]);
        }
      }
      isFirstLoad = false;
    };

    // Initial fetch
    fetchLeads();
    
    // Poll every 30 seconds for updates
    intervalId = setInterval(fetchLeads, 30000);
    
    // Return unsubscribe function
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  },

  // Delete a single lead
  async deleteLead(leadId) {
    try {
      await api.deleteLead(leadId);
      return { success: true };
    } catch (error) {
      console.error('Error deleting lead:', error);
      return { success: false, error: error.message };
    }
  },

  // Delete all leads
  async deleteAllLeads(leadIds = []) {
    try {
      if (leadIds.length === 0) {
        // If no specific IDs provided, get all leads first
        const result = await api.getLeads({ limit: 1000 });
        leadIds = result.leads ? result.leads.map(lead => lead.id) : [];
      }
      
      if (leadIds.length === 0) {
        return { success: true, deleted: 0, failed: 0, total: 0 };
      }
      
      const result = await api.deleteAllLeads(leadIds);
      return { success: true, ...result };
    } catch (error) {
      console.error('Error deleting all leads:', error);
      return { success: false, error: error.message };
    }
  }
};
